// extracted by mini-css-extract-plugin
module.exports = {"loading--mobile":"index_loading--mobile__34Ryv","loading__ins":"index_loading__ins__WPHFp","spin":"index_spin__ffd7w","loading--pc":"index_loading--pc__1J20C"};